import {Swiper, Navigation, Thumbs, Pagination, Zoom} from 'asteq.swiper';
import {BaseDetailSlider} from 'asteq.sliders.basedetailslider';

export class DetailModalSlider extends BaseDetailSlider {
    constructor(sliderBlock, params) {
        super(sliderBlock, params);
    }

    initSwipers() {
        let firstSlide = null;
        
        if (this.thumbsSwiperBlock) {
            this.thumbsSwiper = new Swiper(this.thumbsSwiperBlock,
                {
                    spaceBetween: 16,
                    slidesPerView: 4,
                    freeMode: !0,
                    breakpoints: {
                        1280: {
                            spaceBetween: 22
                        }
                    },
                },
            );

            if (this.thumbsSwiper && this.thumbsSwiper.initialized) {
                firstSlide = this.thumbsSwiper.wrapperEl.children[0];
                if (firstSlide) {
                    this.thumbsSwiperSlideTemplate = firstSlide.cloneNode(true);
                }
            }
        }

        if (this.mainSwiperBlock) {
            let thumbsParams = null;
            if (this.thumbsSwiper) {
                thumbsParams = {
                    swiper: this.thumbsSwiper,
                    slideThumbActiveClass: "!opacity-100",
                };
            }

            this.mainSwiper = new Swiper(this.mainSwiperBlock, {
                modules: [Navigation, Thumbs, Zoom],
                navigation: {
                    prevEl: this.mainSwiperBlock.querySelector('.swiper-button-prev.swiper-main-navigation'),
                    nextEl: this.mainSwiperBlock.querySelector('.swiper-button-next.swiper-main-navigation'),
                },
                thumbs: thumbsParams,
                zoom: {
                    maxRatio: 2,
                },
                on: {
                    zoomChange: (n, r, s) => {
                        s.classList.toggle("!cursor-grab");
                    },
                },
            });

            if (this.mainSwiper && this.mainSwiper.initialized) {
                firstSlide = this.mainSwiper.wrapperEl.children[0];
                if (firstSlide) {
                    this.mainSwiperSlideTemplate = firstSlide.cloneNode(true);
                }
            }
        }

        if (this.thumbsSwiper) {
            this.thumbsSwiper.update();
        }
    }
}